<template>
  <div class="d-flex flex-column align-items-start justify-content-center">
    <p class="text-secondary align-self-center">Create a new account..</p>
    <p class="text-danger">{{errorMessage}}</p>
    <!-- dealer number -->
    <div class="mb-3 w-100 d-flex flex-row align-items-center justify-content-between">
      <label class="pb-0 mb-0 mr-3" for="signup-dealer-number">Dealer number:</label>
      <div class="d-flex flex-column">
        <b-form-input
          v-model="dealerNumber"
          id="signup-dealer-number"
          type="number"
          placeholder="6-8 digits.."
        ></b-form-input>
        <b-form-invalid-feedback id="signup-dealer-number-invalid">invalid</b-form-invalid-feedback>
      </div>
    </div>
    <!-- email -->
    <div class="mb-3 w-100 d-flex flex-row align-items-center justify-content-between">
      <label class="pb-0 mb-0 mr-3" for="signup-email">Email:</label>
      <div>
        <b-form-input v-model="email" id="signup-email" type="email" placeholder="john@email.com"></b-form-input>
        <b-form-invalid-feedback id="signup-email-invalid">invalid</b-form-invalid-feedback>
      </div>
    </div>
    <!-- password -->
    <div class="mb-3 w-100 d-flex flex-row align-items-center justify-content-between">
      <label class="pb-0 mb-0 mr-3" for="signup-password">Password:</label>
      <div>
        <b-form-input
          v-model="password"
          id="signup-password"
          type="password"
          placeholder="Minimum 8 characters.."
        ></b-form-input>
        <b-form-invalid-feedback id="signup-password-invalid">invalid</b-form-invalid-feedback>
      </div>
    </div>
    <!-- confirm password -->
    <div class="mb-3 w-100 d-flex flex-row align-items-center justify-content-between">
      <label class="pb-0 mb-0 mr-3" for="signup-confirm-password">Confirm password:</label>
      <div>
        <b-form-input
          v-model="confirmPassword"
          id="signup-confirm-password"
          type="password"
          placeholder="Minimum 8 characters.."
        ></b-form-input>
        <b-form-invalid-feedback id="signup-confirm-password-invalid">passwords must match!</b-form-invalid-feedback>
      </div>
    </div>
    <b-button variant="primary" @click="requestSignup" class="mt-3 align-self-end">Create new</b-button>
  </div>
</template>

<script>
export default {
  name: "signup-form",
  data() {
    return {
      dealerNumber: "",
      email: "",
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    requestSignup() {
      if (this.$data.confirmPassword != this.$data.password)
        return alert("passwords dont match..");
      if (!this.$data.dealerNumber) return alert("enter a dealer number..");
      if (!this.$data.email) return alert("enter an email..");
      this.$store
        .dispatch("app/signup", {
          dealerNumber: this.$data.dealerNumber,
          email: this.$data.email,
          password: this.$data.password
        })
        .then(() => {
          this.$router.push("/order");
        });
    }
  },
  computed: {
    errorMessage() {
      return this.$store.state.app.signupErrorMessage;
    }
  }
};
</script>

